import { doMutation } from "../../core-module/util/graphqlHelper";

export const approveOrRejectTraining = ({ id, approvalStatus }) => {
  const mutation = require("../api/mutation/approveOrRejectTraining.gql");
  const variables = { id, approvalStatus };

  return doMutation({ mutation, variables }).then(({ data, error }) => {
    if (data) {
      return { data: data.approveOrRejectTraining };
    } else if (error) return { error: JSON.stringify(error) };
  });
};
